
define('text!templates/components/product_reseller_price/product_reseller_prices.html',[],function () { return '<div class="form-group-attached">\n    <div class="row clearfix">\n\n    </div>\n</div>';});

